import { needsToBeAsked } from 'src/lib/cmp_cookies';

const gaPageView = () => {
  document.addEventListener('turbo:load', () => {
    if (!needsToBeAsked && typeof window.gtag === 'function') {
      window.gtag('set', 'page_path', window.location.pathname);
      window.gtag('event', 'page_view');
    } else {
      console.warn('Cannot find gtag in global scope');
    }
  });
};

export default gaPageView;
